export const notificationData = [
  {
    id: 1,
    date: "13 Nov",
    text: "Submitted KYC Application",
    subtitle: "Re-submitted KYC Application form.",
    time: "09:30am",
    fill: "bg-primary",
    outline: true,
  },
  {
    id: 2,
    date: "14 Nov",
    text: "Cancel KYC Application",
    subtitle: "Cancel KYC Application form.",
    time: "09:30am",
    fill: "bg-primary",
    outline: false,
  },
  {
    id: 3,
    date: "15 Nov",
    text: "New KYC Application",
    subtitle: "New application for KYC",
    time: "09:30am",
    fill: "bg-primary",
    outline: false,
  },
];
